import React, { useState, useEffect } from 'react';

/**
 * ContentOverlay component
 * This component provides a full-screen overlay that fades in/out during transitions
 */
const ContentOverlay = () => {
    const [opacity, setOpacity] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);
    
    useEffect(() => {
        const handleFadeOutContent = (event) => {
            //console.log('[ContentOverlay] Fading out content');
            // During transitions, we don't want to show the overlay at all
            // so the transition video can be seen
            setIsTransitioning(true);
            // We'll set opacity to 0 to ensure it's not visible
            setOpacity(0);
        };
        
        const handleFadeInContent = () => {
            //console.log('[ContentOverlay] Fading in content');
            // Reset transition state
            setIsTransitioning(false);
            // Keep opacity at 0 since we don't need the overlay after transitions
            setOpacity(0);
        };
        
        // Listen for fade events
        window.addEventListener('stillLovedFadeOutContent', handleFadeOutContent);
        window.addEventListener('stillLovedFadeInContent', handleFadeInContent);
        
        return () => {
            window.removeEventListener('stillLovedFadeOutContent', handleFadeOutContent);
            window.removeEventListener('stillLovedFadeInContent', handleFadeInContent);
        };
    }, []);
    
    // Log when opacity changes
    useEffect(() => {
        //console.log(`[ContentOverlay] Opacity: ${opacity}`);
    }, [opacity]);
    
    // Don't render anything if opacity is 0 or we're in a transition
    if (opacity === 0 || isTransitioning) return null;
    
    return (
        <div 
            id="still-loved-content-overlay"
            className="fixed inset-0 transition-opacity duration-500 pointer-events-none"
            style={{ 
                opacity,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 50
            }}
        />
    );
};

export default ContentOverlay; 